import { createGetApi, createPostApi } from 'friday-async';

class Apis {
  public list = createGetApi<void>({
    url: '/news/list',
  });

  public create = createPostApi<{
    title: string;
    displayImage: string;
    contentImage?: string;
    status?: string;
  }>({
    url: '/news/create',
  });

  public update = createPostApi<{
    _id: string;
    title: string;
    displayImage: string;
    contentImage?: string;
    status?: string;
  }>({
    url: '/news/update',
  });

  public remove = createPostApi<{_id: string}>({
    url: '/news/remove',
  });
}

export default Apis;
